<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"
        >{{ actionTitle }} {{ $t('CONTACT_PERSONS.ITEM') }}</span
      >
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container grid-list-xl>
          <contact-person-form
            v-model="contactPerson"
            :company="company"
            :errors="errors.getAll()"
            :select-person.sync="selectPerson"
            @update-prop="clearErrorByName($event)"
          ></contact-person-form>
        </v-container>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>

            <v-btn
              color="success"
              :disabled="!valid"
              :loading="isLoading"
              @click="validate"
              >{{ $t('BUTTON.SAVE') }}</v-btn
            >
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';

export default {
  name: 'CreateContactPerson',

  components: {
    ContactPersonForm: () => import('./forms/ContactPersonForm')
  },

  mixins: [errors],

  props: {
    company: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    valid: true,
    selectPerson: true,
    contactPerson: {
      user: {},
      person: {}
    }
  }),

  computed: {
    isLoading() {
      return this.$store.getters['loading'];
    },

    actionTitle() {
      return this.selectPerson ? this.$t('ITEM.ADD') : this.$t('ITEM.CREATE');
    }
  },

  methods: {
    ...mapActions('contact_person', ['storeContactPerson']),

    validate() {
      if (this.$refs.form.validate()) {
        const contactPerson = {
          ...this.contactPerson,
          company_id: this.company.id
        };

        this.storeContactPerson({
          contactPerson
        })
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('created', data.data);
          })
          .catch(({ response }) => {
            this.handleErrorsByResponse(response);
          });
      }
    }
  }
};
</script>
